/**
 * This is the-header script.js file
 */

import TheHeaderActions from '@/components/the-header-actions/index.vue';
import TheHeaderSearch from '@/components/the-header-search/index.vue';

export default {
    name       : 'the-header',
    components : {
        TheHeaderActions,
        TheHeaderSearch
    },
    computed : {
        /**
         * @override
         */
        environment() {
            return this.$store.state.applicationStore.environment;
        }
    }

};
